import { SVGProps } from 'react';

const MetropolisGlyph = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.087 10.423v6.429H9.25v-6.426l3.095 3.211 3.097-3.214v6.429h2.163v-6.426l3.095 3.21 1.591-1.652L16.523 6l-4.177 4.335L8.167 6 2.4 11.984l1.59 1.652z"
    />
  </svg>
);
export default MetropolisGlyph;
